var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClippathgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_873_1006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2513 0H0V50.2513H50.2513V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_873_1006)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_873_1006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 49,
    height: 49
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1255 49.0827C38.3566 49.0827 49.0825 38.3568 49.0825 25.1257C49.0825 11.8946 38.3566 1.1687 25.1255 1.1687C11.8944 1.1687 1.16846 11.8946 1.16846 25.1257C1.16846 38.3568 11.8944 49.0827 25.1255 49.0827Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_873_1006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.3863 45.2265L-10.5933 42.7405C-8.33942 42.5418 -6.15459 42.3179 -4.01575 42.0943C5.66654 41.1496 14.8199 40.23 25.261 40.2051C38.0251 40.1305 46.8565 41.1993 57.0218 42.4174L59.7585 42.7405L59.5055 45.2016L56.7688 44.8785C46.6726 43.6853 37.9331 42.5915 25.261 42.691C14.9118 42.7157 5.82752 43.6106 -3.80876 44.5802C-5.9706 44.8038 -8.15545 45.0028 -10.3863 45.2265Z",
    fill: "#52D4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.3863 45.2265L-10.5933 42.7935C-4.96052 42.2825 0.488298 39.9224 5.75319 37.6355C11.9147 34.9591 18.2832 32.1855 25.2495 32.1611C33.2042 32.2099 39.5497 35.0807 45.6653 37.9518C50.3783 40.1659 54.8384 42.234 59.7585 42.8179L59.5057 45.2265C54.2178 44.6182 49.6196 42.4528 44.7226 40.1659C38.8369 37.4164 32.7213 34.6184 25.2495 34.5943C18.743 34.5943 12.8344 37.1732 6.60385 39.8739C1.17802 42.234 -4.40874 44.6669 -10.4093 45.2265H-10.3863Z",
    fill: "#52D4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.3863 45.2265L-10.5933 42.924C-4.93567 42.4405 0.376929 38.4802 5.98852 34.3129C12.0601 29.8001 18.3156 25.1491 25.261 25.126H25.307C33.1954 25.126 39.3821 30.0762 45.3615 34.8654C50.2143 38.7335 54.7909 42.3946 59.7585 42.9471L59.5055 45.2265C53.8711 44.6049 49.0414 40.7596 43.9128 36.6614C38.2321 32.1255 32.3675 27.4285 25.2841 27.4285H25.2381C19.0515 27.4285 13.095 31.8722 7.32242 36.1777C1.71083 40.3684 -4.10773 44.674 -10.4093 45.2265H-10.3863Z",
    fill: "#52D4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.3863 45.2264L-10.5933 42.8945C-5.0065 42.4048 0.580264 35.8291 5.9831 29.4864C12.0067 22.421 18.2372 15.099 25.2495 15.0757H25.2954C33.2502 15.0757 39.3887 22.8174 45.3203 30.3259C50.2173 36.5053 54.8384 42.3583 59.7585 42.8945L59.5057 45.203C53.6429 44.5503 48.7231 38.3475 43.5271 31.7716C37.9173 24.7062 32.1236 17.3842 25.2954 17.3842H25.2723C19.2948 17.3842 13.4321 24.3098 7.73038 30.9789C2.02868 37.6714 -3.87994 44.5967 -10.3863 45.1799V45.2264Z",
    fill: "#52D4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.3863 46.2315L-10.5933 43.882C-5.55826 43.4355 -1.21302 35.2119 3.40812 26.5184C9.40872 15.2639 15.5932 3.58648 25.3183 4.03292C35.6412 4.52633 41.8256 16.7912 47.2746 27.5993C51.3668 35.7054 55.2294 43.3885 59.7585 43.882L59.5055 46.2081C53.7349 45.5737 49.8035 37.726 45.2284 28.6566C40.0555 18.4359 34.1927 6.80543 25.2035 6.38249C16.9727 5.98307 11.087 17.0026 5.43131 27.6463C0.511292 36.9036 -4.13283 45.6677 -10.3863 46.2315Z",
    fill: "#52D4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6865 49.036C19.9133 49.036 14.9349 48.0076 10.0968 47.026C4.01991 45.7873 -2.26735 44.5016 -10.4478 45.1328L-10.6348 42.7956C-2.12711 42.1177 4.30038 43.4498 10.5409 44.7122C15.4959 45.7406 20.2172 46.6752 25.78 46.6752C32.0438 46.6752 36.7181 45.6235 41.2526 44.6184C46.7684 43.4031 52.4714 42.1411 60.8154 42.7956L60.6284 45.1328C52.635 44.5016 47.3528 45.6702 41.7433 46.9091C37.0923 47.9375 32.2774 49.0127 25.78 49.0127H25.6395L25.6865 49.036Z",
    fill: "#52D4BE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1255 50.1257C11.3349 50.1257 0.125488 38.9164 0.125488 25.1257C0.125488 11.3351 11.3349 0.125732 25.1255 0.125732C38.9162 0.125732 50.1255 11.3351 50.1255 25.1257C50.1255 38.9164 38.9162 50.1257 25.1255 50.1257ZM25.1255 2.21175C12.4816 2.21175 2.2115 12.4818 2.2115 25.1257C2.2115 37.7697 12.4816 48.0398 25.1255 48.0398C37.7695 48.0398 48.0396 37.7697 48.0396 25.1257C48.0396 12.4818 37.7695 2.21175 25.1255 2.21175Z",
    fill: "#52D4BE",
    stroke: "#52D4BE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClippathgroup);
export default __webpack_public_path__ + "static/media/Clip path group.299045344bbace323ed21d011415a529.svg";
export { ForwardRef as ReactComponent };